/**
 * "Tilføj gavepose" checkbox under the add to cart button (product page + quick view).
 *
 * When the box is ticked, the product AND the gift bag are sent to Shopify in ONE request
 * (cart/add with items[0] = product, items[1] = gift bag). The theme's product form already
 * handles this response format, so the cart drawer updates with both in one go.
 *
 * Delegated on document, so it also works for HTML injected into the quick view.
 *
 * Markup (snippets/product-add-to-cart.liquid):
 *   <label class="product-giftbag-addon" data-form-id="<form id>" data-giftbag-variant="<variant id>">
 *     <input type="checkbox"> ...
 *   </label>
 *   <input class="giftbag-wrap-property" name="properties[wrap_type]" disabled>  (inside the form)
 */
(function() {
	if (window.giftBagCheckboxReady) return;
	window.giftBagCheckboxReady = true;

	// NOTE: form.id is shadowed by the form's <input name="id"> (the variant id), so read the attribute
	function formIdOf(form) {
		return form && form.getAttribute ? form.getAttribute('id') : null;
	}

	function labelForForm(form) {
		const id = formIdOf(form);
		if (!id) return null;
		return document.querySelector('.product-giftbag-addon[data-form-id="' + id + '"]');
	}

	// checked -> the jewellery gets the wrap_type property (hidden input in its form)
	document.addEventListener('change', function(event) {
		const label = event.target.closest && event.target.closest('.product-giftbag-addon');
		if (!label) return;
		const form = document.getElementById(label.dataset.formId);
		const wrapProp = form && form.querySelector('.giftbag-wrap-property');
		if (wrapProp) wrapProp.disabled = !event.target.checked;
	});

	// Runs in the capture phase, i.e. just BEFORE the theme reads the form (new FormData(form)).
	document.addEventListener('submit', function(event) {
		const form = event.target;
		const label = labelForForm(form);
		if (!label) return;
		const checkbox = label.querySelector('input[type="checkbox"]');
		if (!checkbox || !checkbox.checked) return;
		const bagVariantId = label.dataset.giftbagVariant;
		if (!bagVariantId) return;

		// make sure the wrap_type property is on (in case "change" didn't fire)
		const wrapProp = form.querySelector('.giftbag-wrap-property');
		if (wrapProp) wrapProp.disabled = false;

		// Turn the single-product fields into items[0][...] and add the bag as items[1]
		const added = [];
		const disabled = [];
		function addField(name, value) {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = name;
			input.value = value;
			form.appendChild(input);
			added.push(input);
		}

		Array.prototype.forEach.call(form.elements, function(el) {
			if (!el.name || el.disabled) return;
			if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
			const name = el.name;
			let itemName = null;
			if (name === 'id') itemName = 'items[0][id]';
			else if (name === 'quantity') itemName = 'items[0][quantity]';
			else if (name === 'selling_plan') itemName = 'items[0][selling_plan]';
			else if (name.indexOf('properties[') === 0) itemName = 'items[0][properties]' + name.slice('properties'.length);
			if (!itemName) return;
			if (el.value === '' && name.indexOf('properties[') === 0) return;
			addField(itemName, el.value);
			el.disabled = true;
			disabled.push(el);
		});

		if (!added.some(function(input) { return input.name === 'items[0][quantity]'; })) {
			addField('items[0][quantity]', '1');
		}
		addField('items[1][id]', bagVariantId);
		addField('items[1][quantity]', '1');

		// restore the form right after the theme has read it
		setTimeout(function() {
			added.forEach(function(input) { input.remove(); });
			disabled.forEach(function(el) { el.disabled = false; });
			if (wrapProp) wrapProp.disabled = !checkbox.checked;
		}, 0);
	}, true);
})();
